import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-64f6e9f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "theme-bar-container"
};
const _hoisted_2 = {
  class: "theme-bar"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "主题配置", -1));
const _hoisted_4 = {
  class: "theme-config"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_remix_icon = _resolveComponent("remix-icon");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return $data.enableThemeBar ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_remix_icon, {
    title: "主题配置",
    icon: "fas fa-palette",
    onClick: $options.handleThemeBarIconClick
  }, null, 8, ["onClick"]), _createElementVNode("ul", _hoisted_2, [_createElementVNode("li", null, [_createElementVNode("div", {
    class: "theme-bar-item",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleThemeBarTextClick && $options.handleThemeBarTextClick(...args))
  }, [_createVNode(_component_remix_icon, {
    icon: "fas fa-palette"
  }), _hoisted_3])])]), _createVNode(_component_el_drawer, {
    title: "主题配置",
    modelValue: $data.themeBarVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.themeBarVisible = $event),
    direction: "rtl",
    "append-to-body": "",
    size: "280px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: $data.themeConfig,
        "label-width": "120px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "布局"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.themeConfig.layout,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.themeConfig.layout = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.layoutOptions, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "样式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.themeConfig.style,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.themeConfig.style = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.styleOptions, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "标签"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: $data.themeConfig.enableTabsBar,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.themeConfig.enableTabsBar = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "头部固定"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: $data.themeConfig.enableHeaderFixed,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.themeConfig.enableHeaderFixed = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.handleSaveThemeClick
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          onClick: $options.handleRestoreDefaultThemeClick
        }, {
          default: _withCtx(() => [_createTextVNode("恢复默认")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true);
}